class MedicationPhotoTab {
  constructor($scope) {
    Object.assign(this, {
      $scope
    });
  }
}

MedicationPhotoTab.$inject = ['$scope'];
angular.module('pims').component('medicationPhotoTab', {
  templateUrl: 'app/views/visits/detail/sections/documents/medication-photo/medication-photo.component.html',
  controller: MedicationPhotoTab,
  controllerAs: 'vm',
  bindings: {
    visit: '=',
  },
});
